module.exports = __webpack_public_path__ + "static/media/save-the-date@2x.d76ab372.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/save-the-date@2x.png
// module id = 1905
// module chunks = 43